// ==================== TRANSLATIONS ====================
// 5 Languages: EN, DE, FR, IT, ES

export const TRANSLATIONS = {
  en: {
    // App
    appName: "VATCalc",
    appTagline: "Free Global VAT Calculator",
    appDescription: "Calculate VAT/IVA/GST for 50+ countries. Add or remove VAT instantly.",
    
    // Navigation
    calculator: "Calculator",
    bulkCalculator: "Bulk Calculator",
    invoiceCalculator: "Invoice Calculator",
    vatRates: "VAT Rates",
    history: "History",
    blog: "Blog",
    
    // Calculator
    selectCountry: "Select Country",
    searchCountry: "Search country...",
    amount: "Amount",
    enterAmount: "Enter amount",
    vatRate: "VAT Rate",
    customRate: "Custom rate",
    operation: "Operation",
    addVat: "Add VAT",
    removeVat: "Remove VAT (Reverse)",
    addVatDesc: "Calculate gross from net amount",
    removeVatDesc: "Extract net from gross amount",
    calculate: "Calculate",
    
    // Results
    results: "Results",
    netAmount: "Net Amount",
    vatAmount: "VAT Amount",
    grossAmount: "Gross Amount",
    
    // Actions
    copy: "Copy",
    copied: "Copied!",
    save: "Save",
    saved: "Saved!",
    reset: "Reset",
    exportPdf: "Export PDF",
    exportCsv: "Export CSV",
    download: "Download",
    upload: "Upload",
    clear: "Clear",
    clearAll: "Clear All",
    delete: "Delete",
    
    // Multi-rate
    multiRateComparison: "Multi-Rate Comparison",
    allRatesFor: "All VAT rates for",
    rate: "Rate",
    net: "Net",
    vat: "VAT",
    gross: "Gross",
    
    // Bulk
    bulkTitle: "Bulk VAT Calculator",
    bulkDescription: "Calculate VAT for multiple amounts at once",
    uploadCsv: "Upload CSV",
    pasteData: "Or paste data",
    processItems: "Process Items",
    maxItems: "Maximum 1000 items",
    totalNet: "Total Net",
    totalVat: "Total VAT",
    totalGross: "Total Gross",
    itemCount: "Items",
    
    // Invoice
    invoiceTitle: "Invoice VAT Calculator",
    invoiceDescription: "Calculate VAT for multiple items with different rates",
    addItem: "Add Item",
    item: "Item",
    description: "Description",
    quantity: "Quantity",
    unitPrice: "Unit Price",
    itemTotal: "Item Total",
    subtotal: "Subtotal (Net)",
    vatBreakdown: "VAT Breakdown",
    invoiceTotal: "Invoice Total",
    generateInvoice: "Generate Invoice",
    
    // History
    calculationHistory: "Calculation History",
    noHistory: "No calculations saved yet",
    reuse: "Reuse",
    deleted: "Deleted",
    historyCleared: "History cleared",
    calculationLoaded: "Calculation loaded",
    historyExported: "History exported",
    justNow: "Just now",
    minutesAgo: "m ago",
    hoursAgo: "h ago",
    daysAgo: "d ago",
    calculationsSaved: "calculations saved",
    calculationSaved: "calculation saved",
    export: "Export",
    
    // Countries
    euCountries: "EU Countries",
    nonEuEurope: "Non-EU Europe",
    restOfWorld: "Rest of World",
    standardRate: "Standard Rate",
    reducedRates: "Reduced Rates",
    currency: "Currency",
    
    // Settings
    settings: "Settings",
    language: "Language",
    theme: "Theme",
    lightMode: "Light Mode",
    darkMode: "Dark Mode",
    decimals: "Decimal Places",
    
    // Footer
    madeWith: "Made with",
    forBusiness: "for businesses worldwide",
    
    // Errors
    error: "Error",
    invalidAmount: "Please enter a valid amount",
    selectCountryFirst: "Please select a country first",
    
    // SEO
    seoTitle: "Free VAT Calculator | Add or Remove VAT Online - VATCalc",
    seoDescription: "Free online VAT calculator for 50+ countries. Add VAT to net amount or remove VAT from gross price. Supports EU VAT, UK VAT, GST and more.",
    
    // Keyboard shortcuts
    keyboardShortcuts: "Keyboard Shortcuts",
    pressEnter: "Press Enter to calculate",
    pressC: "Press C to copy results",
    pressR: "Press R to reset",
    
    // Accessibility
    skipToMain: "Skip to main content",
    skipToNav: "Skip to navigation",
    skipToCalculator: "Skip to calculator",
    accessibilitySettings: "Accessibility Settings",
    accessibilitySettingsDesc: "Customize the display for your needs",
    fontSize: "Font Size",
    reducedMotion: "Reduced Motion",
    reducedMotionDesc: "Minimize animations and transitions",
    highContrast: "High Contrast",
    highContrastDesc: "Increase color contrast for better visibility",
    enhancedFocus: "Enhanced Focus Indicators",
    enhancedFocusDesc: "Larger, more visible focus outlines",
    dyslexiaFont: "Dyslexia-Friendly Font",
    dyslexiaFontDesc: "Use OpenDyslexic font for easier reading",
    resetToDefault: "Reset to Default",
    keyboardShortcutsDesc: "Use these keyboard shortcuts to navigate the application",
    key: "Key",
    action: "Action",
    a11yTabDesc: "Navigate between elements",
    a11yShiftTabDesc: "Navigate backwards",
    a11yEnterDesc: "Activate button or calculate",
    
    // Accessibility Widget additional
    quickProfiles: "Quick Profiles",
    visionImpaired: "Vision",
    cognitive: "Cognitive",
    dyslexia: "Dyslexia",
    readingGuide: "Reading Guide",
    readingGuideDesc: "Highlight current reading line",
    saturation: "Color Saturation",
    shortcutHint: "Press",
    toToggle: "to toggle",
    autoDetected: "Auto-detects system preferences",
    a11ySpaceDesc: "Toggle checkbox or button",
    a11yEscapeDesc: "Close dialog or dropdown",
    a11yArrowDesc: "Navigate within components",
    a11ySlashDesc: "Focus search field",
    calculationComplete: "Calculation complete",
    resultCopied: "Result copied to clipboard",
    resultSaved: "Result saved to history",
    languageChanged: "Language changed to",
    themeChanged: "Theme changed to"
  },
  
  de: {
    // App
    appName: "MwSt-Rechner",
    appTagline: "Kostenloser Mehrwertsteuer-Rechner",
    appDescription: "Berechnen Sie MwSt/USt für 50+ Länder. Mehrwertsteuer hinzufügen oder herausrechnen.",
    
    // Navigation
    calculator: "Rechner",
    bulkCalculator: "Massenberechnung",
    invoiceCalculator: "Rechnungsrechner",
    vatRates: "MwSt-Sätze",
    history: "Verlauf",
    blog: "Blog",
    
    // Calculator
    selectCountry: "Land auswählen",
    searchCountry: "Land suchen...",
    amount: "Betrag",
    enterAmount: "Betrag eingeben",
    vatRate: "MwSt-Satz",
    customRate: "Eigener Satz",
    operation: "Berechnung",
    addVat: "MwSt hinzufügen",
    removeVat: "MwSt herausrechnen",
    addVatDesc: "Brutto aus Netto berechnen",
    removeVatDesc: "Netto aus Brutto berechnen",
    calculate: "Berechnen",
    
    // Results
    results: "Ergebnisse",
    netAmount: "Nettobetrag",
    vatAmount: "MwSt-Betrag",
    grossAmount: "Bruttobetrag",
    
    // Actions
    copy: "Kopieren",
    copied: "Kopiert!",
    save: "Speichern",
    saved: "Gespeichert!",
    reset: "Zurücksetzen",
    exportPdf: "PDF exportieren",
    exportCsv: "CSV exportieren",
    download: "Herunterladen",
    upload: "Hochladen",
    clear: "Löschen",
    clearAll: "Alles löschen",
    delete: "Entfernen",
    
    // Multi-rate
    multiRateComparison: "Vergleich aller Steuersätze",
    allRatesFor: "Alle MwSt-Sätze für",
    rate: "Satz",
    net: "Netto",
    vat: "MwSt",
    gross: "Brutto",
    
    // Bulk
    bulkTitle: "Massenberechnung MwSt",
    bulkDescription: "MwSt für mehrere Beträge auf einmal berechnen",
    uploadCsv: "CSV hochladen",
    pasteData: "Oder Daten einfügen",
    processItems: "Verarbeiten",
    maxItems: "Maximal 1000 Einträge",
    totalNet: "Gesamt Netto",
    totalVat: "Gesamt MwSt",
    totalGross: "Gesamt Brutto",
    itemCount: "Einträge",
    
    // Invoice
    invoiceTitle: "Rechnungs-MwSt-Rechner",
    invoiceDescription: "MwSt für mehrere Artikel mit verschiedenen Sätzen berechnen",
    addItem: "Artikel hinzufügen",
    item: "Artikel",
    description: "Beschreibung",
    quantity: "Menge",
    unitPrice: "Einzelpreis",
    itemTotal: "Artikelsumme",
    subtotal: "Zwischensumme (Netto)",
    vatBreakdown: "MwSt-Aufschlüsselung",
    invoiceTotal: "Rechnungssumme",
    generateInvoice: "Rechnung erstellen",
    
    // History
    calculationHistory: "Berechnungsverlauf",
    noHistory: "Noch keine Berechnungen gespeichert",
    reuse: "Wiederverwenden",
    deleted: "Gelöscht",
    historyCleared: "Verlauf gelöscht",
    calculationLoaded: "Berechnung geladen",
    historyExported: "Verlauf exportiert",
    justNow: "Gerade eben",
    minutesAgo: "Min. her",
    hoursAgo: "Std. her",
    daysAgo: "T. her",
    calculationsSaved: "Berechnungen gespeichert",
    calculationSaved: "Berechnung gespeichert",
    export: "Exportieren",
    
    // Countries
    euCountries: "EU-Länder",
    nonEuEurope: "Nicht-EU Europa",
    restOfWorld: "Rest der Welt",
    standardRate: "Standardsatz",
    reducedRates: "Ermäßigte Sätze",
    currency: "Währung",
    
    // Settings
    settings: "Einstellungen",
    language: "Sprache",
    theme: "Design",
    lightMode: "Hell",
    darkMode: "Dunkel",
    decimals: "Dezimalstellen",
    
    // Footer
    madeWith: "Erstellt mit",
    forBusiness: "für Unternehmen weltweit",
    
    // Errors
    error: "Fehler",
    invalidAmount: "Bitte geben Sie einen gültigen Betrag ein",
    selectCountryFirst: "Bitte wählen Sie zuerst ein Land",
    
    // SEO
    seoTitle: "MwSt Rechner Kostenlos | Mehrwertsteuer Berechnen Online",
    seoDescription: "Kostenloser MwSt-Rechner für 50+ Länder. Mehrwertsteuer hinzufügen oder herausrechnen. Unterstützt EU-MwSt, USt und mehr.",
    
    // Keyboard shortcuts
    keyboardShortcuts: "Tastaturkürzel",
    pressEnter: "Enter drücken zum Berechnen",
    pressC: "C drücken zum Kopieren",
    pressR: "R drücken zum Zurücksetzen",
    
    // Accessibility
    skipToMain: "Zum Hauptinhalt springen",
    skipToNav: "Zur Navigation springen",
    skipToCalculator: "Zum Rechner springen",
    accessibilitySettings: "Barrierefreiheit",
    accessibilitySettingsDesc: "Passen Sie die Anzeige an Ihre Bedürfnisse an",
    fontSize: "Schriftgröße",
    reducedMotion: "Reduzierte Bewegung",
    reducedMotionDesc: "Animationen und Übergänge minimieren",
    highContrast: "Hoher Kontrast",
    highContrastDesc: "Farbkontrast für bessere Sichtbarkeit erhöhen",
    enhancedFocus: "Verbesserte Fokusanzeigen",
    enhancedFocusDesc: "Größere, sichtbarere Fokusrahmen",
    dyslexiaFont: "Legasthenie-freundliche Schrift",
    dyslexiaFontDesc: "OpenDyslexic-Schrift für leichteres Lesen",
    resetToDefault: "Auf Standard zurücksetzen",
    keyboardShortcutsDesc: "Diese Tastaturkürzel zur Navigation verwenden",
    key: "Taste",
    action: "Aktion",
    a11yTabDesc: "Zwischen Elementen navigieren",
    a11yShiftTabDesc: "Rückwärts navigieren",
    a11yEnterDesc: "Schaltfläche aktivieren oder berechnen",
    a11ySpaceDesc: "Kontrollkästchen oder Schaltfläche umschalten",
    a11yEscapeDesc: "Dialog oder Dropdown schließen",
    a11yArrowDesc: "Innerhalb von Komponenten navigieren",
    a11ySlashDesc: "Suchfeld fokussieren",
    calculationComplete: "Berechnung abgeschlossen",
    resultCopied: "Ergebnis in Zwischenablage kopiert",
    resultSaved: "Ergebnis im Verlauf gespeichert",
    languageChanged: "Sprache geändert zu",
    themeChanged: "Design geändert zu",
    
    // Accessibility Widget additional
    quickProfiles: "Schnellprofile",
    visionImpaired: "Sehbehindert",
    cognitive: "Kognitiv",
    dyslexia: "Legasthenie",
    readingGuide: "Lesehilfe",
    readingGuideDesc: "Aktuelle Lesezeile hervorheben",
    saturation: "Farbsättigung",
    shortcutHint: "Drücken Sie",
    toToggle: "zum Umschalten",
    autoDetected: "Erkennt Systemeinstellungen automatisch"
  },
  
  fr: {
    // App
    appName: "Calcul TVA",
    appTagline: "Calculateur TVA Gratuit",
    appDescription: "Calculez la TVA pour 50+ pays. Ajoutez ou retirez la TVA instantanément.",
    
    // Navigation
    calculator: "Calculateur",
    bulkCalculator: "Calcul en masse",
    invoiceCalculator: "Calcul facture",
    vatRates: "Taux TVA",
    history: "Historique",
    blog: "Blog",
    
    // Calculator
    selectCountry: "Sélectionner un pays",
    searchCountry: "Rechercher un pays...",
    amount: "Montant",
    enterAmount: "Entrer le montant",
    vatRate: "Taux TVA",
    customRate: "Taux personnalisé",
    operation: "Opération",
    addVat: "Ajouter TVA",
    removeVat: "Retirer TVA",
    addVatDesc: "Calculer TTC à partir du HT",
    removeVatDesc: "Calculer HT à partir du TTC",
    calculate: "Calculer",
    
    // Results
    results: "Résultats",
    netAmount: "Montant HT",
    vatAmount: "Montant TVA",
    grossAmount: "Montant TTC",
    
    // Actions
    copy: "Copier",
    copied: "Copié!",
    save: "Enregistrer",
    saved: "Enregistré!",
    reset: "Réinitialiser",
    exportPdf: "Exporter PDF",
    exportCsv: "Exporter CSV",
    download: "Télécharger",
    upload: "Importer",
    clear: "Effacer",
    clearAll: "Tout effacer",
    delete: "Supprimer",
    
    // Multi-rate
    multiRateComparison: "Comparaison multi-taux",
    allRatesFor: "Tous les taux TVA pour",
    rate: "Taux",
    net: "HT",
    vat: "TVA",
    gross: "TTC",
    
    // Bulk
    bulkTitle: "Calcul TVA en masse",
    bulkDescription: "Calculez la TVA pour plusieurs montants à la fois",
    uploadCsv: "Importer CSV",
    pasteData: "Ou coller les données",
    processItems: "Traiter",
    maxItems: "Maximum 1000 éléments",
    totalNet: "Total HT",
    totalVat: "Total TVA",
    totalGross: "Total TTC",
    itemCount: "Éléments",
    
    // Invoice
    invoiceTitle: "Calculateur TVA Facture",
    invoiceDescription: "Calculez la TVA pour plusieurs articles avec différents taux",
    addItem: "Ajouter article",
    item: "Article",
    description: "Description",
    quantity: "Quantité",
    unitPrice: "Prix unitaire",
    itemTotal: "Total article",
    subtotal: "Sous-total (HT)",
    vatBreakdown: "Détail TVA",
    invoiceTotal: "Total facture",
    generateInvoice: "Générer facture",
    
    // History
    calculationHistory: "Historique des calculs",
    noHistory: "Aucun calcul enregistré",
    reuse: "Réutiliser",
    deleted: "Supprimé",
    historyCleared: "Historique effacé",
    calculationLoaded: "Calcul chargé",
    historyExported: "Historique exporté",
    justNow: "À l'instant",
    minutesAgo: "min",
    hoursAgo: "h",
    daysAgo: "j",
    calculationsSaved: "calculs enregistrés",
    calculationSaved: "calcul enregistré",
    export: "Exporter",
    
    // Countries
    euCountries: "Pays UE",
    nonEuEurope: "Europe hors UE",
    restOfWorld: "Reste du monde",
    standardRate: "Taux standard",
    reducedRates: "Taux réduits",
    currency: "Devise",
    
    // Settings
    settings: "Paramètres",
    language: "Langue",
    theme: "Thème",
    lightMode: "Mode clair",
    darkMode: "Mode sombre",
    decimals: "Décimales",
    
    // Footer
    madeWith: "Créé avec",
    forBusiness: "pour les entreprises du monde entier",
    
    // Errors
    error: "Erreur",
    invalidAmount: "Veuillez entrer un montant valide",
    selectCountryFirst: "Veuillez d'abord sélectionner un pays",
    
    // SEO
    seoTitle: "Calcul TVA Gratuit | Calculer TVA en ligne - VATCalc",
    seoDescription: "Calculateur TVA gratuit pour 50+ pays. Ajoutez ou retirez la TVA. Supporte TVA UE, TVA UK, TPS et plus.",
    
    // Keyboard shortcuts
    keyboardShortcuts: "Raccourcis clavier",
    pressEnter: "Appuyez sur Entrée pour calculer",
    pressC: "Appuyez sur C pour copier",
    pressR: "Appuyez sur R pour réinitialiser",
    
    // Accessibility
    skipToMain: "Aller au contenu principal",
    skipToNav: "Aller à la navigation",
    skipToCalculator: "Aller au calculateur",
    accessibilitySettings: "Accessibilité",
    accessibilitySettingsDesc: "Personnalisez l'affichage selon vos besoins",
    fontSize: "Taille de police",
    reducedMotion: "Mouvement réduit",
    reducedMotionDesc: "Minimiser les animations et transitions",
    highContrast: "Contraste élevé",
    highContrastDesc: "Augmenter le contraste des couleurs",
    enhancedFocus: "Indicateurs de focus améliorés",
    enhancedFocusDesc: "Contours de focus plus grands et visibles",
    dyslexiaFont: "Police adaptée à la dyslexie",
    dyslexiaFontDesc: "Utiliser OpenDyslexic pour une lecture facilitée",
    resetToDefault: "Réinitialiser par défaut",
    keyboardShortcutsDesc: "Utilisez ces raccourcis pour naviguer",
    key: "Touche",
    action: "Action",
    a11yTabDesc: "Naviguer entre les éléments",
    a11yShiftTabDesc: "Naviguer en arrière",
    a11yEnterDesc: "Activer le bouton ou calculer",
    a11ySpaceDesc: "Basculer case à cocher ou bouton",
    a11yEscapeDesc: "Fermer dialogue ou menu déroulant",
    a11yArrowDesc: "Naviguer dans les composants",
    a11ySlashDesc: "Focaliser le champ de recherche",
    calculationComplete: "Calcul terminé",
    resultCopied: "Résultat copié dans le presse-papiers",
    resultSaved: "Résultat enregistré dans l'historique",
    languageChanged: "Langue changée en",
    themeChanged: "Thème changé en",
    
    // Accessibility Widget additional
    quickProfiles: "Profils rapides",
    visionImpaired: "Malvoyant",
    cognitive: "Cognitif",
    dyslexia: "Dyslexie",
    readingGuide: "Guide de lecture",
    readingGuideDesc: "Mettre en évidence la ligne actuelle",
    saturation: "Saturation des couleurs",
    shortcutHint: "Appuyez sur",
    toToggle: "pour basculer",
    autoDetected: "Détecte automatiquement les préférences système"
  },
  
  it: {
    // App
    appName: "Calcolo IVA",
    appTagline: "Calcolatore IVA Gratuito",
    appDescription: "Calcola IVA per 50+ paesi. Aggiungi o scorpora IVA istantaneamente.",
    
    // Navigation
    calculator: "Calcolatore",
    bulkCalculator: "Calcolo multiplo",
    invoiceCalculator: "Calcolo fattura",
    vatRates: "Aliquote IVA",
    history: "Cronologia",
    blog: "Blog",
    
    // Calculator
    selectCountry: "Seleziona Paese",
    searchCountry: "Cerca paese...",
    amount: "Importo",
    enterAmount: "Inserisci importo",
    vatRate: "Aliquota IVA",
    customRate: "Aliquota personalizzata",
    operation: "Operazione",
    addVat: "Aggiungi IVA",
    removeVat: "Scorpora IVA",
    addVatDesc: "Calcola lordo da netto",
    removeVatDesc: "Calcola netto da lordo",
    calculate: "Calcola",
    
    // Results
    results: "Risultati",
    netAmount: "Importo Netto",
    vatAmount: "Importo IVA",
    grossAmount: "Importo Lordo",
    
    // Actions
    copy: "Copia",
    copied: "Copiato!",
    save: "Salva",
    saved: "Salvato!",
    reset: "Reimposta",
    exportPdf: "Esporta PDF",
    exportCsv: "Esporta CSV",
    download: "Scarica",
    upload: "Carica",
    clear: "Cancella",
    clearAll: "Cancella tutto",
    delete: "Elimina",
    
    // Multi-rate
    multiRateComparison: "Confronto multi-aliquota",
    allRatesFor: "Tutte le aliquote IVA per",
    rate: "Aliquota",
    net: "Netto",
    vat: "IVA",
    gross: "Lordo",
    
    // Bulk
    bulkTitle: "Calcolo IVA Multiplo",
    bulkDescription: "Calcola IVA per più importi contemporaneamente",
    uploadCsv: "Carica CSV",
    pasteData: "Oppure incolla i dati",
    processItems: "Elabora",
    maxItems: "Massimo 1000 elementi",
    totalNet: "Totale Netto",
    totalVat: "Totale IVA",
    totalGross: "Totale Lordo",
    itemCount: "Elementi",
    
    // Invoice
    invoiceTitle: "Calcolatore IVA Fattura",
    invoiceDescription: "Calcola IVA per più articoli con aliquote diverse",
    addItem: "Aggiungi articolo",
    item: "Articolo",
    description: "Descrizione",
    quantity: "Quantità",
    unitPrice: "Prezzo unitario",
    itemTotal: "Totale articolo",
    subtotal: "Subtotale (Netto)",
    vatBreakdown: "Dettaglio IVA",
    invoiceTotal: "Totale fattura",
    generateInvoice: "Genera fattura",
    
    // History
    calculationHistory: "Cronologia calcoli",
    noHistory: "Nessun calcolo salvato",
    reuse: "Riutilizza",
    deleted: "Eliminato",
    historyCleared: "Cronologia cancellata",
    calculationLoaded: "Calcolo caricato",
    historyExported: "Cronologia esportata",
    justNow: "Adesso",
    minutesAgo: "min fa",
    hoursAgo: "ore fa",
    daysAgo: "g fa",
    calculationsSaved: "calcoli salvati",
    calculationSaved: "calcolo salvato",
    export: "Esporta",
    
    // Countries
    euCountries: "Paesi UE",
    nonEuEurope: "Europa non UE",
    restOfWorld: "Resto del mondo",
    standardRate: "Aliquota standard",
    reducedRates: "Aliquote ridotte",
    currency: "Valuta",
    
    // Settings
    settings: "Impostazioni",
    language: "Lingua",
    theme: "Tema",
    lightMode: "Modalità chiara",
    darkMode: "Modalità scura",
    decimals: "Decimali",
    
    // Footer
    madeWith: "Creato con",
    forBusiness: "per le aziende di tutto il mondo",
    
    // Errors
    error: "Errore",
    invalidAmount: "Inserisci un importo valido",
    selectCountryFirst: "Seleziona prima un paese",
    
    // SEO
    seoTitle: "Calcolo IVA Online Gratis | Scorporo IVA - VATCalc",
    seoDescription: "Calcolatore IVA gratuito per 50+ paesi. Aggiungi o scorpora IVA. Supporta IVA UE, VAT UK, GST e altro.",
    
    // Keyboard shortcuts
    keyboardShortcuts: "Scorciatoie da tastiera",
    pressEnter: "Premi Invio per calcolare",
    pressC: "Premi C per copiare",
    pressR: "Premi R per reimpostare",
    
    // Accessibility
    skipToMain: "Vai al contenuto principale",
    skipToNav: "Vai alla navigazione",
    skipToCalculator: "Vai al calcolatore",
    accessibilitySettings: "Accessibilità",
    accessibilitySettingsDesc: "Personalizza la visualizzazione per le tue esigenze",
    fontSize: "Dimensione carattere",
    reducedMotion: "Movimento ridotto",
    reducedMotionDesc: "Minimizza animazioni e transizioni",
    highContrast: "Alto contrasto",
    highContrastDesc: "Aumenta il contrasto dei colori per una migliore visibilità",
    enhancedFocus: "Indicatori di focus migliorati",
    enhancedFocusDesc: "Contorni di focus più grandi e visibili",
    dyslexiaFont: "Font per dislessia",
    dyslexiaFontDesc: "Usa OpenDyslexic per una lettura più facile",
    resetToDefault: "Ripristina predefiniti",
    keyboardShortcutsDesc: "Usa queste scorciatoie per navigare l'applicazione",
    key: "Tasto",
    action: "Azione",
    a11yTabDesc: "Naviga tra gli elementi",
    a11yShiftTabDesc: "Naviga all'indietro",
    a11yEnterDesc: "Attiva pulsante o calcola",
    a11ySpaceDesc: "Attiva/disattiva checkbox o pulsante",
    a11yEscapeDesc: "Chiudi dialogo o menu",
    a11yArrowDesc: "Naviga nei componenti",
    a11ySlashDesc: "Focus sul campo di ricerca",
    calculationComplete: "Calcolo completato",
    resultCopied: "Risultato copiato negli appunti",
    resultSaved: "Risultato salvato nella cronologia",
    languageChanged: "Lingua cambiata in",
    themeChanged: "Tema cambiato in",
    
    // Accessibility Widget additional
    quickProfiles: "Profili rapidi",
    visionImpaired: "Ipovedenti",
    cognitive: "Cognitivo",
    dyslexia: "Dislessia",
    readingGuide: "Guida di lettura",
    readingGuideDesc: "Evidenzia la riga corrente",
    saturation: "Saturazione colori",
    shortcutHint: "Premi",
    toToggle: "per attivare/disattivare",
    autoDetected: "Rileva automaticamente le preferenze di sistema"
  },
  
  es: {
    // App
    appName: "Calculadora IVA",
    appTagline: "Calculadora IVA Gratuita",
    appDescription: "Calcula IVA para 50+ países. Añade o elimina IVA al instante.",
    
    // Navigation
    calculator: "Calculadora",
    bulkCalculator: "Cálculo masivo",
    invoiceCalculator: "Cálculo factura",
    vatRates: "Tipos IVA",
    history: "Historial",
    blog: "Blog",
    
    // Calculator
    selectCountry: "Seleccionar país",
    searchCountry: "Buscar país...",
    amount: "Importe",
    enterAmount: "Introducir importe",
    vatRate: "Tipo IVA",
    customRate: "Tipo personalizado",
    operation: "Operación",
    addVat: "Añadir IVA",
    removeVat: "Quitar IVA",
    addVatDesc: "Calcular bruto desde neto",
    removeVatDesc: "Calcular neto desde bruto",
    calculate: "Calcular",
    
    // Results
    results: "Resultados",
    netAmount: "Importe Neto",
    vatAmount: "Importe IVA",
    grossAmount: "Importe Bruto",
    
    // Actions
    copy: "Copiar",
    copied: "¡Copiado!",
    save: "Guardar",
    saved: "¡Guardado!",
    reset: "Restablecer",
    exportPdf: "Exportar PDF",
    exportCsv: "Exportar CSV",
    download: "Descargar",
    upload: "Subir",
    clear: "Borrar",
    clearAll: "Borrar todo",
    delete: "Eliminar",
    
    // Multi-rate
    multiRateComparison: "Comparación multi-tipo",
    allRatesFor: "Todos los tipos IVA para",
    rate: "Tipo",
    net: "Neto",
    vat: "IVA",
    gross: "Bruto",
    
    // Bulk
    bulkTitle: "Cálculo IVA Masivo",
    bulkDescription: "Calcula IVA para múltiples importes a la vez",
    uploadCsv: "Subir CSV",
    pasteData: "O pegar datos",
    processItems: "Procesar",
    maxItems: "Máximo 1000 elementos",
    totalNet: "Total Neto",
    totalVat: "Total IVA",
    totalGross: "Total Bruto",
    itemCount: "Elementos",
    
    // Invoice
    invoiceTitle: "Calculadora IVA Factura",
    invoiceDescription: "Calcula IVA para múltiples artículos con diferentes tipos",
    addItem: "Añadir artículo",
    item: "Artículo",
    description: "Descripción",
    quantity: "Cantidad",
    unitPrice: "Precio unitario",
    itemTotal: "Total artículo",
    subtotal: "Subtotal (Neto)",
    vatBreakdown: "Desglose IVA",
    invoiceTotal: "Total factura",
    generateInvoice: "Generar factura",
    
    // History
    calculationHistory: "Historial de cálculos",
    noHistory: "Sin cálculos guardados",
    reuse: "Reutilizar",
    deleted: "Eliminado",
    historyCleared: "Historial borrado",
    calculationLoaded: "Cálculo cargado",
    historyExported: "Historial exportado",
    justNow: "Ahora mismo",
    minutesAgo: "min",
    hoursAgo: "h",
    daysAgo: "d",
    calculationsSaved: "cálculos guardados",
    calculationSaved: "cálculo guardado",
    export: "Exportar",
    
    // Countries
    euCountries: "Países UE",
    nonEuEurope: "Europa no UE",
    restOfWorld: "Resto del mundo",
    standardRate: "Tipo estándar",
    reducedRates: "Tipos reducidos",
    currency: "Moneda",
    
    // Settings
    settings: "Ajustes",
    language: "Idioma",
    theme: "Tema",
    lightMode: "Modo claro",
    darkMode: "Modo oscuro",
    decimals: "Decimales",
    
    // Footer
    madeWith: "Hecho con",
    forBusiness: "para empresas de todo el mundo",
    
    // Errors
    error: "Error",
    invalidAmount: "Por favor introduce un importe válido",
    selectCountryFirst: "Por favor selecciona primero un país",
    
    // SEO
    seoTitle: "Calculadora IVA Gratis | Calcular IVA Online - VATCalc",
    seoDescription: "Calculadora IVA gratuita para 50+ países. Añade o quita IVA. Soporta IVA UE, VAT UK, IVA LATAM y más.",
    
    // Keyboard shortcuts
    keyboardShortcuts: "Atajos de teclado",
    pressEnter: "Pulsa Enter para calcular",
    pressC: "Pulsa C para copiar",
    pressR: "Pulsa R para restablecer",
    
    // Accessibility
    skipToMain: "Ir al contenido principal",
    skipToNav: "Ir a la navegación",
    skipToCalculator: "Ir a la calculadora",
    accessibilitySettings: "Accesibilidad",
    accessibilitySettingsDesc: "Personaliza la visualización según tus necesidades",
    fontSize: "Tamaño de fuente",
    reducedMotion: "Movimiento reducido",
    reducedMotionDesc: "Minimizar animaciones y transiciones",
    highContrast: "Alto contraste",
    highContrastDesc: "Aumentar el contraste de colores para mejor visibilidad",
    enhancedFocus: "Indicadores de enfoque mejorados",
    enhancedFocusDesc: "Contornos de enfoque más grandes y visibles",
    dyslexiaFont: "Fuente para dislexia",
    dyslexiaFontDesc: "Usar OpenDyslexic para una lectura más fácil",
    resetToDefault: "Restablecer valores predeterminados",
    keyboardShortcutsDesc: "Usa estos atajos para navegar la aplicación",
    key: "Tecla",
    action: "Acción",
    a11yTabDesc: "Navegar entre elementos",
    a11yShiftTabDesc: "Navegar hacia atrás",
    a11yEnterDesc: "Activar botón o calcular",
    a11ySpaceDesc: "Alternar casilla o botón",
    a11yEscapeDesc: "Cerrar diálogo o menú desplegable",
    a11yArrowDesc: "Navegar dentro de componentes",
    a11ySlashDesc: "Enfocar campo de búsqueda",
    calculationComplete: "Cálculo completado",
    resultCopied: "Resultado copiado al portapapeles",
    resultSaved: "Resultado guardado en el historial",
    languageChanged: "Idioma cambiado a",
    themeChanged: "Tema cambiado a",
    
    // Accessibility Widget additional
    quickProfiles: "Perfiles rápidos",
    visionImpaired: "Discapacidad visual",
    cognitive: "Cognitivo",
    dyslexia: "Dislexia",
    readingGuide: "Guía de lectura",
    readingGuideDesc: "Resaltar la línea actual de lectura",
    saturation: "Saturación de colores",
    shortcutHint: "Pulsa",
    toToggle: "para alternar",
    autoDetected: "Detecta automáticamente las preferencias del sistema"
  }
};

export const LANGUAGE_OPTIONS = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'es', name: 'Español', flag: '🇪🇸' }
];

// Country name translations for SEO - all 62 countries
export const COUNTRY_NAMES = {
  en: {
    'AL': 'Albania', 'AR': 'Argentina', 'AU': 'Australia', 'AT': 'Austria', 'BE': 'Belgium',
    'BA': 'Bosnia and Herzegovina', 'BR': 'Brazil', 'BG': 'Bulgaria', 'CA': 'Canada', 'CL': 'Chile',
    'CO': 'Colombia', 'HR': 'Croatia', 'CY': 'Cyprus', 'CZ': 'Czech Republic', 'DK': 'Denmark',
    'EG': 'Egypt', 'EE': 'Estonia', 'FI': 'Finland', 'FR': 'France', 'DE': 'Germany',
    'GR': 'Greece', 'HU': 'Hungary', 'IS': 'Iceland', 'IN': 'India', 'ID': 'Indonesia',
    'IE': 'Ireland', 'IL': 'Israel', 'IT': 'Italy', 'JP': 'Japan', 'KE': 'Kenya',
    'LV': 'Latvia', 'LT': 'Lithuania', 'LU': 'Luxembourg', 'MY': 'Malaysia', 'MT': 'Malta',
    'MX': 'Mexico', 'ME': 'Montenegro', 'NL': 'Netherlands', 'NZ': 'New Zealand', 'NG': 'Nigeria',
    'MK': 'North Macedonia', 'NO': 'Norway', 'PH': 'Philippines', 'PL': 'Poland', 'PT': 'Portugal',
    'RO': 'Romania', 'SA': 'Saudi Arabia', 'RS': 'Serbia', 'SG': 'Singapore', 'SK': 'Slovakia',
    'SI': 'Slovenia', 'ZA': 'South Africa', 'KR': 'South Korea', 'ES': 'Spain', 'SE': 'Sweden',
    'CH': 'Switzerland', 'TH': 'Thailand', 'TR': 'Turkey', 'AE': 'UAE', 'UA': 'Ukraine',
    'GB': 'United Kingdom', 'VN': 'Vietnam'
  },
  de: {
    'AL': 'Albanien', 'AR': 'Argentinien', 'AU': 'Australien', 'AT': 'Österreich', 'BE': 'Belgien',
    'BA': 'Bosnien und Herzegowina', 'BR': 'Brasilien', 'BG': 'Bulgarien', 'CA': 'Kanada', 'CL': 'Chile',
    'CO': 'Kolumbien', 'HR': 'Kroatien', 'CY': 'Zypern', 'CZ': 'Tschechien', 'DK': 'Dänemark',
    'EG': 'Ägypten', 'EE': 'Estland', 'FI': 'Finnland', 'FR': 'Frankreich', 'DE': 'Deutschland',
    'GR': 'Griechenland', 'HU': 'Ungarn', 'IS': 'Island', 'IN': 'Indien', 'ID': 'Indonesien',
    'IE': 'Irland', 'IL': 'Israel', 'IT': 'Italien', 'JP': 'Japan', 'KE': 'Kenia',
    'LV': 'Lettland', 'LT': 'Litauen', 'LU': 'Luxemburg', 'MY': 'Malaysia', 'MT': 'Malta',
    'MX': 'Mexiko', 'ME': 'Montenegro', 'NL': 'Niederlande', 'NZ': 'Neuseeland', 'NG': 'Nigeria',
    'MK': 'Nordmazedonien', 'NO': 'Norwegen', 'PH': 'Philippinen', 'PL': 'Polen', 'PT': 'Portugal',
    'RO': 'Rumänien', 'SA': 'Saudi-Arabien', 'RS': 'Serbien', 'SG': 'Singapur', 'SK': 'Slowakei',
    'SI': 'Slowenien', 'ZA': 'Südafrika', 'KR': 'Südkorea', 'ES': 'Spanien', 'SE': 'Schweden',
    'CH': 'Schweiz', 'TH': 'Thailand', 'TR': 'Türkei', 'AE': 'VAE', 'UA': 'Ukraine',
    'GB': 'Vereinigtes Königreich', 'VN': 'Vietnam'
  },
  fr: {
    'AL': 'Albanie', 'AR': 'Argentine', 'AU': 'Australie', 'AT': 'Autriche', 'BE': 'Belgique',
    'BA': 'Bosnie-Herzégovine', 'BR': 'Brésil', 'BG': 'Bulgarie', 'CA': 'Canada', 'CL': 'Chili',
    'CO': 'Colombie', 'HR': 'Croatie', 'CY': 'Chypre', 'CZ': 'Tchéquie', 'DK': 'Danemark',
    'EG': 'Égypte', 'EE': 'Estonie', 'FI': 'Finlande', 'FR': 'France', 'DE': 'Allemagne',
    'GR': 'Grèce', 'HU': 'Hongrie', 'IS': 'Islande', 'IN': 'Inde', 'ID': 'Indonésie',
    'IE': 'Irlande', 'IL': 'Israël', 'IT': 'Italie', 'JP': 'Japon', 'KE': 'Kenya',
    'LV': 'Lettonie', 'LT': 'Lituanie', 'LU': 'Luxembourg', 'MY': 'Malaisie', 'MT': 'Malte',
    'MX': 'Mexique', 'ME': 'Monténégro', 'NL': 'Pays-Bas', 'NZ': 'Nouvelle-Zélande', 'NG': 'Nigeria',
    'MK': 'Macédoine du Nord', 'NO': 'Norvège', 'PH': 'Philippines', 'PL': 'Pologne', 'PT': 'Portugal',
    'RO': 'Roumanie', 'SA': 'Arabie Saoudite', 'RS': 'Serbie', 'SG': 'Singapour', 'SK': 'Slovaquie',
    'SI': 'Slovénie', 'ZA': 'Afrique du Sud', 'KR': 'Corée du Sud', 'ES': 'Espagne', 'SE': 'Suède',
    'CH': 'Suisse', 'TH': 'Thaïlande', 'TR': 'Turquie', 'AE': 'EAU', 'UA': 'Ukraine',
    'GB': 'Royaume-Uni', 'VN': 'Vietnam'
  },
  it: {
    'AL': 'Albania', 'AR': 'Argentina', 'AU': 'Australia', 'AT': 'Austria', 'BE': 'Belgio',
    'BA': 'Bosnia ed Erzegovina', 'BR': 'Brasile', 'BG': 'Bulgaria', 'CA': 'Canada', 'CL': 'Cile',
    'CO': 'Colombia', 'HR': 'Croazia', 'CY': 'Cipro', 'CZ': 'Repubblica Ceca', 'DK': 'Danimarca',
    'EG': 'Egitto', 'EE': 'Estonia', 'FI': 'Finlandia', 'FR': 'Francia', 'DE': 'Germania',
    'GR': 'Grecia', 'HU': 'Ungheria', 'IS': 'Islanda', 'IN': 'India', 'ID': 'Indonesia',
    'IE': 'Irlanda', 'IL': 'Israele', 'IT': 'Italia', 'JP': 'Giappone', 'KE': 'Kenya',
    'LV': 'Lettonia', 'LT': 'Lituania', 'LU': 'Lussemburgo', 'MY': 'Malesia', 'MT': 'Malta',
    'MX': 'Messico', 'ME': 'Montenegro', 'NL': 'Paesi Bassi', 'NZ': 'Nuova Zelanda', 'NG': 'Nigeria',
    'MK': 'Macedonia del Nord', 'NO': 'Norvegia', 'PH': 'Filippine', 'PL': 'Polonia', 'PT': 'Portogallo',
    'RO': 'Romania', 'SA': 'Arabia Saudita', 'RS': 'Serbia', 'SG': 'Singapore', 'SK': 'Slovacchia',
    'SI': 'Slovenia', 'ZA': 'Sudafrica', 'KR': 'Corea del Sud', 'ES': 'Spagna', 'SE': 'Svezia',
    'CH': 'Svizzera', 'TH': 'Thailandia', 'TR': 'Turchia', 'AE': 'EAU', 'UA': 'Ucraina',
    'GB': 'Regno Unito', 'VN': 'Vietnam'
  },
  es: {
    'AL': 'Albania', 'AR': 'Argentina', 'AU': 'Australia', 'AT': 'Austria', 'BE': 'Bélgica',
    'BA': 'Bosnia y Herzegovina', 'BR': 'Brasil', 'BG': 'Bulgaria', 'CA': 'Canadá', 'CL': 'Chile',
    'CO': 'Colombia', 'HR': 'Croacia', 'CY': 'Chipre', 'CZ': 'República Checa', 'DK': 'Dinamarca',
    'EG': 'Egipto', 'EE': 'Estonia', 'FI': 'Finlandia', 'FR': 'Francia', 'DE': 'Alemania',
    'GR': 'Grecia', 'HU': 'Hungría', 'IS': 'Islandia', 'IN': 'India', 'ID': 'Indonesia',
    'IE': 'Irlanda', 'IL': 'Israel', 'IT': 'Italia', 'JP': 'Japón', 'KE': 'Kenia',
    'LV': 'Letonia', 'LT': 'Lituania', 'LU': 'Luxemburgo', 'MY': 'Malasia', 'MT': 'Malta',
    'MX': 'México', 'ME': 'Montenegro', 'NL': 'Países Bajos', 'NZ': 'Nueva Zelanda', 'NG': 'Nigeria',
    'MK': 'Macedonia del Norte', 'NO': 'Noruega', 'PH': 'Filipinas', 'PL': 'Polonia', 'PT': 'Portugal',
    'RO': 'Rumanía', 'SA': 'Arabia Saudita', 'RS': 'Serbia', 'SG': 'Singapur', 'SK': 'Eslovaquia',
    'SI': 'Eslovenia', 'ZA': 'Sudáfrica', 'KR': 'Corea del Sur', 'ES': 'España', 'SE': 'Suecia',
    'CH': 'Suiza', 'TH': 'Tailandia', 'TR': 'Turquía', 'AE': 'EAU', 'UA': 'Ucrania',
    'GB': 'Reino Unido', 'VN': 'Vietnam'
  }
};

// Get translated country name
export const getCountryName = (countryCode, lang = 'en') => {
  return COUNTRY_NAMES[lang]?.[countryCode] || COUNTRY_NAMES['en']?.[countryCode] || countryCode;
};

export const getTranslation = (lang, key) => {
  return TRANSLATIONS[lang]?.[key] || TRANSLATIONS['en'][key] || key;
};

export const t = getTranslation;

// ==================== SEO TITLES ====================
// Optimized page titles for each language - 2026 updated
export const SEO_TITLES = {
  en: {
    home: "VAT Calculator Free | Add Remove VAT Online - vat.expert",
    homeAlt: "Free VAT Calculator 2026 | Calculate VAT for 62 Countries",
    calculator: "VAT Calculator | Add or Remove VAT Instantly",
    bulk: "Bulk VAT Calculator | CSV Upload - Process 1000 Items",
    invoice: "Invoice VAT Calculator | Multi-Rate Professional Tool",
    rates: "VAT Rates 2026 | All 62 Countries Tax Rates",
    history: "VAT Calculation History | Track Your Calculations",
    blog: "VAT Blog | Tax News, Updates & Guides 2026"
  },
  de: {
    home: "MwSt Rechner Kostenlos | Mehrwertsteuer Berechnen Online",
    homeAlt: "Kostenloser MwSt Rechner 2026 | 62 Länder",
    calculator: "MwSt Rechner | Brutto Netto Sofort Berechnen",
    bulk: "MwSt Massenrechner | CSV Upload - 1000 Einträge",
    invoice: "Rechnungs MwSt Rechner | Multi-Rate Professionell",
    rates: "MwSt Sätze 2026 | Alle 62 Länder Steuersätze",
    history: "MwSt Berechnungsverlauf | Ihre Berechnungen",
    blog: "MwSt Blog | Steuer-News & Ratgeber 2026"
  },
  fr: {
    home: "Calculateur TVA Gratuit | Ajouter Retirer TVA en Ligne",
    homeAlt: "Calculateur TVA Gratuit 2026 | 62 Pays",
    calculator: "Calculateur TVA | HT TTC Instantané",
    bulk: "Calculateur TVA en Masse | CSV - 1000 Lignes",
    invoice: "Calculateur TVA Facture | Multi-Taux Professionnel",
    rates: "Taux TVA 2026 | 62 Pays Taux d'Imposition",
    history: "Historique Calculs TVA | Suivez Vos Calculs",
    blog: "Blog TVA | Actualités Fiscales & Guides 2026"
  },
  it: {
    home: "Calcolatore IVA Gratis | Aggiungi Scorpora IVA Online",
    homeAlt: "Calcolatore IVA Gratuito 2026 | 62 Paesi",
    calculator: "Calcolatore IVA | Netto Lordo Istantaneo",
    bulk: "Calcolatore IVA Multiplo | CSV - 1000 Righe",
    invoice: "Calcolatore IVA Fattura | Multi-Aliquota Professionale",
    rates: "Aliquote IVA 2026 | 62 Paesi Tassi Fiscali",
    history: "Cronologia Calcoli IVA | Traccia i Tuoi Calcoli",
    blog: "Blog IVA | Notizie Fiscali & Guide 2026"
  },
  es: {
    home: "Calculadora IVA Gratis | Añadir Quitar IVA Online",
    homeAlt: "Calculadora IVA Gratuita 2026 | 62 Países",
    calculator: "Calculadora IVA | Neto Bruto Instantáneo",
    bulk: "Calculadora IVA Masiva | CSV - 1000 Líneas",
    invoice: "Calculadora IVA Factura | Multi-Tipo Profesional",
    rates: "Tipos IVA 2026 | 62 Países Tasas Fiscales",
    history: "Historial Cálculos IVA | Rastrea Tus Cálculos",
    blog: "Blog IVA | Noticias Fiscales & Guías 2026"
  }
};

// ==================== SEO DESCRIPTIONS ====================
// Meta descriptions optimized for search engines - 2026 updated
export const SEO_DESCRIPTIONS = {
  en: {
    home: "Free professional VAT calculator for 62 countries. Add VAT to net or remove VAT from gross instantly. EU VAT, UK VAT, GST. WCAG accessible. Updated 2026.",
    calculator: "Calculate VAT instantly with our free online tool. Add VAT to net prices or remove VAT from gross amounts. Supports all EU and global tax rates.",
    bulk: "Process up to 1000 VAT calculations at once. Upload CSV files or paste data directly. Bulk VAT calculator for businesses. Export results to CSV/PDF.",
    invoice: "Professional invoice VAT calculator with multi-rate support. Calculate VAT for multiple items with different tax rates. Perfect for accountants and businesses.",
    rates: "Complete VAT rates guide for 62 countries in 2026. EU VAT rates, UK VAT, GST rates. Standard, reduced, and zero rates. Updated monthly.",
    history: "Track all your VAT calculations in one place. Save, export, and reuse calculations. Free calculation history with no signup required.",
    blog: "Stay updated with the latest VAT news, tax changes, and expert guides. EU VAT updates, Brexit implications, and international tax insights.",
    country: (name, rate, taxName) => `Calculate ${taxName} for ${name} instantly. ${rate}% standard rate. Add or remove VAT free. Professional tool. Updated 2026.`,
    countryRates: (name, taxName) => `Complete ${taxName} rates for ${name} in 2026. Standard, reduced, and special rates. Free VAT calculator included.`
  },
  de: {
    home: "Kostenloser professioneller MwSt-Rechner für 62 Länder. Mehrwertsteuer hinzufügen oder herausrechnen. EU-MwSt, UK VAT, GST. WCAG-konform. Aktualisiert 2026.",
    calculator: "Berechnen Sie MwSt sofort mit unserem kostenlosen Online-Tool. Brutto aus Netto oder Netto aus Brutto. Alle EU- und globalen Steuersätze.",
    bulk: "Bis zu 1000 MwSt-Berechnungen auf einmal verarbeiten. CSV-Dateien hochladen oder Daten direkt einfügen. Export nach CSV/PDF.",
    invoice: "Professioneller Rechnungs-MwSt-Rechner mit Multi-Rate-Unterstützung. Berechnen Sie MwSt für mehrere Artikel mit verschiedenen Steuersätzen.",
    rates: "Vollständiger MwSt-Sätze-Leitfaden für 62 Länder 2026. EU-MwSt-Sätze, UK VAT, GST-Sätze. Monatlich aktualisiert.",
    history: "Verfolgen Sie alle Ihre MwSt-Berechnungen an einem Ort. Speichern, exportieren und wiederverwenden. Keine Anmeldung erforderlich.",
    blog: "Bleiben Sie auf dem Laufenden mit den neuesten MwSt-Nachrichten, Steueränderungen und Expertenratgebern.",
    country: (name, rate, taxName) => `Berechnen Sie ${taxName} für ${name} sofort. ${rate}% Standardsatz. MwSt kostenlos hinzufügen oder herausrechnen. Aktualisiert 2026.`,
    countryRates: (name, taxName) => `Vollständige ${taxName}-Sätze für ${name} 2026. Standard-, ermäßigte und Sondersätze. Kostenloser MwSt-Rechner inklusive.`
  },
  fr: {
    home: "Calculateur TVA professionnel gratuit pour 62 pays. Ajouter ou retirer la TVA instantanément. TVA UE, UK VAT, TPS. Conforme WCAG. Mis à jour 2026.",
    calculator: "Calculez la TVA instantanément avec notre outil en ligne gratuit. Ajoutez la TVA aux prix HT ou retirez la TVA des montants TTC.",
    bulk: "Traitez jusqu'à 1000 calculs de TVA à la fois. Téléchargez des fichiers CSV ou collez les données directement. Export CSV/PDF.",
    invoice: "Calculateur TVA professionnel pour factures avec support multi-taux. Calculez la TVA pour plusieurs articles avec différents taux.",
    rates: "Guide complet des taux de TVA pour 62 pays en 2026. Taux TVA UE, UK VAT, taux TPS. Mis à jour mensuellement.",
    history: "Suivez tous vos calculs de TVA en un seul endroit. Enregistrez, exportez et réutilisez. Aucune inscription requise.",
    blog: "Restez informé des dernières actualités TVA, changements fiscaux et guides d'experts.",
    country: (name, rate, taxName) => `Calculez la ${taxName} pour ${name} instantanément. Taux standard ${rate}%. Ajoutez ou retirez la TVA gratuitement. Mis à jour 2026.`,
    countryRates: (name, taxName) => `Taux ${taxName} complets pour ${name} en 2026. Taux standard, réduits et spéciaux. Calculateur TVA gratuit inclus.`
  },
  it: {
    home: "Calcolatore IVA professionale gratuito per 62 paesi. Aggiungi o scorpora IVA istantaneamente. IVA UE, UK VAT, GST. Conforme WCAG. Aggiornato 2026.",
    calculator: "Calcola l'IVA istantaneamente con il nostro strumento online gratuito. Aggiungi IVA ai prezzi netti o scorpora IVA dagli importi lordi.",
    bulk: "Elabora fino a 1000 calcoli IVA contemporaneamente. Carica file CSV o incolla i dati direttamente. Esporta in CSV/PDF.",
    invoice: "Calcolatore IVA professionale per fatture con supporto multi-aliquota. Calcola IVA per più articoli con aliquote diverse.",
    rates: "Guida completa alle aliquote IVA per 62 paesi nel 2026. Aliquote IVA UE, UK VAT, aliquote GST. Aggiornato mensilmente.",
    history: "Traccia tutti i tuoi calcoli IVA in un unico posto. Salva, esporta e riutilizza. Nessuna registrazione richiesta.",
    blog: "Rimani aggiornato sulle ultime notizie IVA, modifiche fiscali e guide degli esperti.",
    country: (name, rate, taxName) => `Calcola ${taxName} per ${name} istantaneamente. Aliquota standard ${rate}%. Aggiungi o scorpora IVA gratis. Aggiornato 2026.`,
    countryRates: (name, taxName) => `Aliquote ${taxName} complete per ${name} nel 2026. Aliquote standard, ridotte e speciali. Calcolatore IVA gratuito incluso.`
  },
  es: {
    home: "Calculadora IVA profesional gratuita para 62 países. Añade o quita IVA instantáneamente. IVA UE, UK VAT, GST. Conforme WCAG. Actualizado 2026.",
    calculator: "Calcula el IVA instantáneamente con nuestra herramienta online gratuita. Añade IVA a precios netos o quita IVA de importes brutos.",
    bulk: "Procesa hasta 1000 cálculos de IVA a la vez. Sube archivos CSV o pega los datos directamente. Exporta a CSV/PDF.",
    invoice: "Calculadora IVA profesional para facturas con soporte multi-tipo. Calcula IVA para múltiples artículos con diferentes tipos.",
    rates: "Guía completa de tipos de IVA para 62 países en 2026. Tipos IVA UE, UK VAT, tipos GST. Actualizado mensualmente.",
    history: "Rastrea todos tus cálculos de IVA en un solo lugar. Guarda, exporta y reutiliza. Sin registro requerido.",
    blog: "Mantente informado sobre las últimas noticias de IVA, cambios fiscales y guías de expertos.",
    country: (name, rate, taxName) => `Calcula ${taxName} para ${name} instantáneamente. Tipo estándar ${rate}%. Añade o quita IVA gratis. Actualizado 2026.`,
    countryRates: (name, taxName) => `Tipos ${taxName} completos para ${name} en 2026. Tipos estándar, reducidos y especiales. Calculadora IVA gratuita incluida.`
  }
};

// ==================== CTA TRANSLATIONS ====================
// Call-to-action button text for each language
export const CTA_TRANSLATIONS = {
  en: {
    calculate: "Calculate Now",
    calculateVat: "Calculate VAT",
    tryFree: "Try Free",
    getStarted: "Get Started",
    learnMore: "Learn More",
    viewRates: "View All Rates",
    uploadFile: "Upload File",
    exportResults: "Export Results",
    saveCalculation: "Save Calculation",
    startCalculating: "Start Calculating",
    tryBulkCalculator: "Try Bulk Calculator",
    viewHistory: "View History",
    readMore: "Read More",
    seeAllCountries: "See All Countries",
    compareRates: "Compare Rates"
  },
  de: {
    calculate: "Jetzt Berechnen",
    calculateVat: "MwSt Berechnen",
    tryFree: "Kostenlos Testen",
    getStarted: "Loslegen",
    learnMore: "Mehr Erfahren",
    viewRates: "Alle Sätze Anzeigen",
    uploadFile: "Datei Hochladen",
    exportResults: "Ergebnisse Exportieren",
    saveCalculation: "Berechnung Speichern",
    startCalculating: "Berechnung Starten",
    tryBulkCalculator: "Massenrechner Testen",
    viewHistory: "Verlauf Anzeigen",
    readMore: "Mehr Lesen",
    seeAllCountries: "Alle Länder Anzeigen",
    compareRates: "Sätze Vergleichen"
  },
  fr: {
    calculate: "Calculer Maintenant",
    calculateVat: "Calculer TVA",
    tryFree: "Essayer Gratuitement",
    getStarted: "Commencer",
    learnMore: "En Savoir Plus",
    viewRates: "Voir Tous les Taux",
    uploadFile: "Télécharger Fichier",
    exportResults: "Exporter Résultats",
    saveCalculation: "Enregistrer Calcul",
    startCalculating: "Commencer le Calcul",
    tryBulkCalculator: "Essayer le Calcul en Masse",
    viewHistory: "Voir l'Historique",
    readMore: "Lire Plus",
    seeAllCountries: "Voir Tous les Pays",
    compareRates: "Comparer les Taux"
  },
  it: {
    calculate: "Calcola Ora",
    calculateVat: "Calcola IVA",
    tryFree: "Prova Gratis",
    getStarted: "Inizia",
    learnMore: "Scopri di Più",
    viewRates: "Vedi Tutte le Aliquote",
    uploadFile: "Carica File",
    exportResults: "Esporta Risultati",
    saveCalculation: "Salva Calcolo",
    startCalculating: "Inizia a Calcolare",
    tryBulkCalculator: "Prova Calcolo Multiplo",
    viewHistory: "Vedi Cronologia",
    readMore: "Leggi di Più",
    seeAllCountries: "Vedi Tutti i Paesi",
    compareRates: "Confronta Aliquote"
  },
  es: {
    calculate: "Calcular Ahora",
    calculateVat: "Calcular IVA",
    tryFree: "Probar Gratis",
    getStarted: "Comenzar",
    learnMore: "Saber Más",
    viewRates: "Ver Todos los Tipos",
    uploadFile: "Subir Archivo",
    exportResults: "Exportar Resultados",
    saveCalculation: "Guardar Cálculo",
    startCalculating: "Empezar a Calcular",
    tryBulkCalculator: "Probar Cálculo Masivo",
    viewHistory: "Ver Historial",
    readMore: "Leer Más",
    seeAllCountries: "Ver Todos los Países",
    compareRates: "Comparar Tipos"
  }
};

// ==================== SEO KEYWORDS ====================
// Primary keywords for each language
export const SEO_KEYWORDS = {
  en: [
    "VAT calculator",
    "VAT calculator online",
    "free VAT calculator",
    "add VAT",
    "remove VAT",
    "VAT reverse calculator",
    "EU VAT calculator",
    "UK VAT calculator",
    "GST calculator",
    "tax calculator",
    "VAT rates 2026",
    "calculate VAT from gross",
    "calculate VAT from net"
  ],
  de: [
    "MwSt Rechner",
    "Mehrwertsteuer Rechner",
    "MwSt Rechner kostenlos",
    "MwSt hinzufügen",
    "MwSt herausrechnen",
    "Brutto Netto Rechner",
    "MwSt Sätze 2026",
    "Umsatzsteuer Rechner",
    "MwSt berechnen"
  ],
  fr: [
    "calculateur TVA",
    "calcul TVA",
    "calculette TVA gratuite",
    "ajouter TVA",
    "retirer TVA",
    "TVA HT TTC",
    "taux TVA 2026",
    "calculateur TVA en ligne"
  ],
  it: [
    "calcolatore IVA",
    "calcolo IVA",
    "calcolatore IVA online",
    "aggiungere IVA",
    "scorporare IVA",
    "calcolo IVA netto lordo",
    "aliquote IVA 2026",
    "calcolo IVA inverso"
  ],
  es: [
    "calculadora IVA",
    "calcular IVA",
    "calculadora IVA gratis",
    "añadir IVA",
    "quitar IVA",
    "IVA neto bruto",
    "tipos IVA 2026",
    "calculadora IVA online"
  ]
};

// ==================== STRUCTURED DATA HELPERS ====================
// Helper functions for generating SEO content
export const getSeoTitle = (lang, page) => {
  return SEO_TITLES[lang]?.[page] || SEO_TITLES['en']?.[page] || '';
};

export const getSeoDescription = (lang, page) => {
  const desc = SEO_DESCRIPTIONS[lang]?.[page];
  if (typeof desc === 'function') return desc;
  return desc || SEO_DESCRIPTIONS['en']?.[page] || '';
};

export const getCtaText = (lang, action) => {
  return CTA_TRANSLATIONS[lang]?.[action] || CTA_TRANSLATIONS['en']?.[action] || action;
};

export const getSeoKeywords = (lang) => {
  return SEO_KEYWORDS[lang] || SEO_KEYWORDS['en'];
};

// Generate country-specific SEO description
export const getCountrySeoDescription = (lang, countryName, rate, taxName = 'VAT') => {
  const descFn = SEO_DESCRIPTIONS[lang]?.country;
  if (typeof descFn === 'function') {
    return descFn(countryName, rate, taxName);
  }
  return SEO_DESCRIPTIONS['en'].country(countryName, rate, taxName);
};

// Generate country rates page SEO description
export const getCountryRatesSeoDescription = (lang, countryName, taxName = 'VAT') => {
  const descFn = SEO_DESCRIPTIONS[lang]?.countryRates;
  if (typeof descFn === 'function') {
    return descFn(countryName, taxName);
  }
  return SEO_DESCRIPTIONS['en'].countryRates(countryName, taxName);
};
